import Accordion from '@ui/Accordion';
import RadioButton from '@ui/RadioButton';
import { getGenderLabel } from '@util/createListingHelpers';
import { slugify } from '@util/urlHelpers';
import { FacetCountValue } from 'models/product';
import { Gender } from 'models/shared';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FilterItem } from '../Filters';

type Props = {
  filterOptions?: FilterItem[];
  onChange: (keys: string[]) => void;
  title: string;
  initialFilters: string[];
  noFiltersMessage?: string;
  startOpen?: boolean;
  facet_counts?: FacetCountValue[];
  titleClassName?: string;
  pendingFilters?: string[];
};

const RadioFilterSection = ({
  filterOptions,
  onChange,
  title,
  initialFilters,
  noFiltersMessage,
  startOpen,
  facet_counts,
  titleClassName,
  pendingFilters,
}: Props) => {
  const pathname = usePathname();
  const handleRadioChange = (key: string) => {
    if (initialFilters?.includes(key)) {
      onChange([]);
    } else {
      onChange([key]);
    }
  };

  function getHref(opt: string) {
    const segments = pathname?.split('/');
    if (!segments) return '/';
    const path = pathname?.split('/').slice(0, segments.length - 1);
    const lastCat = pathname?.split('/')[segments.length - 1];
    const optSlug = title.includes('Gender')
      ? getGenderLabel(opt as Gender).toLowerCase()
      : slugify(opt);
    return (
      (initialFilters?.length > 0 ? '/filters' : '') +
      path?.join('/') +
      '/' +
      optSlug +
      (lastCat ? '-' + lastCat : '')
    );
  }

  return (
    <Accordion
      title={title}
      titleClassName={titleClassName}
      startOpen={startOpen}
    >
      <div className="flex max-h-[25rem] flex-col gap-[1.2rem] overflow-scroll p-[1.2rem]">
        {filterOptions && filterOptions.length > 0 ? (
          filterOptions?.map((opt) => (
            <div className="flex items-center gap-4" key={opt.key}>
              <RadioButton
                onClick={() => handleRadioChange(opt.key)}
                label={opt.label}
                checked={
                  !!(
                    initialFilters?.some(
                      (x) =>
                        slugify(x.toLowerCase()) ===
                        slugify(opt.key.toLowerCase())
                    ) ||
                    pendingFilters?.some(
                      (x) =>
                        slugify(x.toLowerCase()) ===
                        slugify(opt.key.toLowerCase())
                    )
                  )
                }
              />
              {!!facet_counts?.find((c) => c.value === opt.key) && (
                <span className="text-[1.2rem] text-brand-dark-gray">
                  ({facet_counts.find((c) => c.value === opt.key)?.count})
                </span>
              )}
              <Link hidden href={getHref(opt.key)}>
                {opt.label}
              </Link>
            </div>
          ))
        ) : (
          <p className="text-center">{noFiltersMessage}</p>
        )}
      </div>
    </Accordion>
  );
};

export default RadioFilterSection;
